// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form[data-v-49f06e06]{max-width:425px;margin:125px auto 0}@media(max-width:991px){.form[data-v-49f06e06]{margin-top:75px}}@media(max-width:767px){.form[data-v-49f06e06]{margin-top:60px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
